<template>
  <div class="qrCodeBody">
    <Header />
    <div class="qrCodeMain" v-loading="loading">
      <Step :num='4' authType="1" />
      <div class="infoMainBody">
        <div class="infoArea">
          <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="170px" label-position="right">
            <el-form-item label="法定代表人姓名" prop="">
              <el-input v-model="infoForm.name" disabled size="small" placeholder="请输入法定代表人姓名" maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="法定代表人身份证件号" prop="">
              <el-input v-model="infoForm.identNo" disabled size="small" placeholder="请输入法定代表人身份证件号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="法定代表人验证方式" prop="">
              <el-radio-group v-model="infoForm.mode" class="verifyType" @input="getMode">
                <el-radio-button :disabled="!infoForm.faceMode" :label="2" index="2">刷脸认证</el-radio-button>
                <el-radio-button :disabled="!infoForm.middleMode" :label="0" index="0">实名手机号验证</el-radio-button>
              </el-radio-group>
              <p v-if="infoForm.mode==2">根据页面提示完成人脸识别，并与公安部预留人像进行比对认证；使用此认证方式，视为您同意平台采集您的人脸信息用于实名认证</p>
              <p v-if="infoForm.mode==0">与运营商手机号实名信息比对验证，请确保手机号已通过运营商实名认证</p>
            </el-form-item>
            <div class="qrCode" v-if="infoForm.mode == 2 && infoForm.faceMode">
              <div class="leftArea">
                <div class="codeArea">
                  <img :src="'data:image/png;base64,' + img">
                  <dl v-if="isScanning">
                    <dt><img src="@/assets/image/accomplish.png"></dt>
                    <dd>扫码成功</dd>
                  </dl>
                </div>
                <h5><em @click="getCreateFaceUrl">刷新</em></h5>
                <h5>请使用手机微信扫一扫</h5>
                <h5>并依照提示完成人脸识别</h5>
              </div>
              <div class="demonstration">
                <img src="@/assets/image/demonstration.png">
              </div>
            </div>
            <div v-if="infoForm.mode == 0 && infoForm.middleMode">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="infoForm.mobile" size="small" placeholder="请输入手机号" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="smsCode">
                <el-input class="verificationCode" v-model="infoForm.smsCode" size="small" placeholder="请输入验证码" maxlength="6"></el-input>
                <el-button class="codeBtn" plain size="small" :disabled="countDown>0" @click="getCode">{{countDown>0?`重新获取(${countDown})`:'获取验证码'}}</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="lineBtn">
        <el-button size="mini" @click="getRoute">上一步</el-button>
        <el-button v-if="infoForm.mode == 0" type="primary" size="mini" @click="getLegalPersonVerify()">下一步 </el-button>
      </div>
    </div>
    <authResult :verifyMsg="verifyMsg" :face="face" :authAgent="authAgent" v-show="authCompletedShow" @blockAuth="getRoute" @blockFace="blockFace"></authResult>
  </div>
</template>

<script>
import { validMobile } from '@/utils/validate'
import authResult from './authResult.vue'
export default {
  data() {
    return {
      loading: false,
      img: '',
      intervals: [],
      isScanning: false,
      orderNo: sessionStorage.getItem('order'),
      // infoForm: JSON.parse(sessionStorage.getItem('infoForm')),
      infoForm: {
        name: '',
        mode: 2,
        mobile: '',
        identType: 0,
        identNo: null,
        smsCode: ''
      },
      countDown: 0,
      authCompletedShow: false,
      verifyMsg: '',
      face: false,
      authAgent: false,
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            message: '请输入正确的手机号码',
            validator: validMobile,
            trigger: 'blur'
          }
        ],
        smsCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getLegalPersonInfo()
  },
  components: {
    authResult
  },
  methods: {
    blockFace() {
      this.authCompletedShow = false
      this.isScanning = false
      this.getBackStep()
    },
    getRoute() {
      if (this.$store.state.userInfo.havaAgentAuth) {
        this.$router.push({ name: 'companyAgentScanningCode' })
      } else {
        this.$router.push({ name: 'companyEntryInfo' })
      }
    },
    getBackStep() {
      this.countDown = 0
      this.infoForm.mobile = ''
      this.infoForm.smsCode = ''
      this.authCompletedShow = false
      this.getLegalPersonInfo()
    },
    getResult() {
      this.$alert('未查到人脸结果，请扫描二维码并完成人脸识别！', '提示', {
        confirmButtonText: '好的',
        type: 'warning'
      })
    },
    getMode(id) {
      this.clearInterval()
      this.countDown = 0
      if (id === 2) this.getCreateFaceUrl()
      this.$api
        .getLegalPersonAuthMode({
          flowId: this.$store.state.userInfo.flowId,
          legalPersonAuthMode: this.infoForm.mode
        })
        .then(res => {
          if (res.code && res.code !== '0') {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.authCompletedShow = true
          // this.face = true
          // if (err.code === ' 810401' || err.code === ' 810403') {
          //   this.face = false
          // }
          this.verifyMsg = err.msg
        })
    },
    getLegalPersonInfo() {
      this.loading = true
      this.authAgent = false
      this.$api
        .getLegalPersonInfo({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.$set(this.infoForm, 'name', res.data.legalPersonName)
            this.$set(this.infoForm, 'identNo', res.data.legalPersonId)
            this.$set(
              this.infoForm,
              'faceMode',
              res.data.legalPersonAvailableAuthTypes
                .split(',')
                .includes('PSN_FACEAUTH_BYURL')
            )
            this.$set(
              this.infoForm,
              'middleMode',
              res.data.legalPersonAvailableAuthTypes
                .split(',')
                .includes('PSN_TELECOM_AUTHCODE')
            )

            if (this.infoForm.middleMode && !this.infoForm.faceMode) {
              this.$set(this.infoForm, 'mode', 0)
            }
            if (this.infoForm.faceMode && !this.infoForm.middleMode) {
              this.$set(this.infoForm, 'mode', 2)
            }
            this.$nextTick(() => {
              if (this.infoForm.mode === 2) {
                this.getLegalPersonVerify()
              } else {
                this.loading = false
              }
            })
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.loading = false
          if (err.code === ' 810404') {
            this.getRoute()
          } else if (err.code === '810414') {
            //810414 未完成办理人认证,无法继续认证
            this.authCompletedShow = true
            this.verifyMsg = err.msg
            this.authAgent = true
          } else {
            this.authCompletedShow = true
            // this.face = true
            // if (err.code === ' 810401' || err.code === ' 810403') {
            //   this.face = false
            // }
            this.verifyMsg = err.msg
          }
        })
    },
    getLegalPersonVerify() {
      let data = {
        flowId: this.$store.state.userInfo.flowId,
        legalPersonAuthMode: this.infoForm.mode
      }
      if (this.infoForm.mode === 0) {
        data.legalPersonMobile = this.infoForm.mobile
        data.smsCode = this.infoForm.smsCode
      }
      this.$refs['infoForm'].validate(valid => {
        if (valid) {
          this.$api
            .getLegalPersonVerify(data)
            .then(res => {
              if (res.code && res.code === '0') {
                if (
                  res.data.qrCodeResponseVO &&
                  res.data.qrCodeResponseVO.fileBytes &&
                  this.infoForm.mode === 2
                ) {
                  this.$set(
                    this,
                    'img',
                    res.data.qrCodeResponseVO &&
                      res.data.qrCodeResponseVO.fileBytes
                      ? res.data.qrCodeResponseVO.fileBytes
                      : this.img
                  )
                  this.intervals.push(
                    setInterval(() => {
                      this.getAuthPersonStatus()
                    }, 3000)
                  )
                } else {
                  this.$router.push({ name: 'authSuccess' })
                }
                this.loading = false
              } else {
                return new Promise((resolve, reject) => {
                  reject(res)
                })
              }
            })
            .catch(err => {
              this.loading = false
              if (err.code === '6003') {
                this.$alert(err.msg, '提示', {
                  confirmButtonText: '好的',
                  callback: () => {
                    this.getRoute()
                  }
                })
              } else if (err.code === '810414') {
                //810414 未完成办理人认证,无法继续认证
                this.authAgent = true
                this.clearInterval()
                this.authCompletedShow = true
                this.verifyMsg = err.msg
              } else {
                this.clearInterval()
                this.authCompletedShow = true
                this.verifyMsg = err.msg
              }
            })
        }
      })
    },
    getCreateFaceUrl() {
      // this.isLoad = true
      this.clearInterval()
      this.$api
        .getPersonFace({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.img = res.data.fileBytes
            this.orderNo = res.data.order
            this.isScanning = false
            this.intervals.push(
              setInterval(() => {
                this.getAuthPersonStatus()
              }, 3000)
            )
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(() => {
          this.clearInterval()
          // this.isLoad = false
        })
    },
    getAuthPersonStatus() {
      this.$api
        .checkVerifyStatus({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            if (res.data.status === 'DOING') {
              this.isScanning = true
            } else if (res.data.status === 'PASSED') {
              this.clearInterval()
              this.$router.push({ name: 'authSuccess' })
            } else if (res.data.status === 'FAILED') {
              return new Promise((resolve, reject) => {
                reject(res)
              })
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.clearInterval()
          this.authCompletedShow = true
          // this.face = true
          // if (err.code === '810403') {
          //   this.face = false
          // }
          if (err.code === '810414') {
            //810414 未完成办理人认证,无法继续认证
            this.authAgent = true
          }
          this.verifyMsg = err.msg
        })
    },
    getCode() {
      this.$refs.infoForm.validateField('mobile', err => {
        if (!err) {
          this.$tencentCaptcha(val => {
            this.countDown = 60
            val['mobile'] = this.infoForm.mobile
            val['flowId'] = this.$store.state.userInfo.flowId
            this.$api
              .sendSmsCode(val)
              .then(res => {
                if (res.code === '0') {
                  this.infoForm.smsToken = res.data.sms_token
                  this.intervals.push(
                    setInterval(() => {
                      this.countDown--
                      if (this.countDown == 0) {
                        this.clearInterval()
                      }
                    }, 1000)
                  )
                } else {
                  return new Promise((resolve, reject) => {
                    reject(res)
                  })
                }
              })
              .catch(err => {
                this.clearInterval()
                this.countDown = 0
                this.$alert(err.msg, '提示', {
                  confirmButtonText: '好的',
                  callback: () => {}
                })
              })
          })
        }
      })
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    }
  },
  destroyed() {
    this.clearInterval()
  }
}
</script>

<style lang="scss" scoped>
.qrCodeBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.qrCodeMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.qrCode {
  width: max-content;
  margin: 64px 0 0 160px;
  display: flex;
}
.leftArea {
  text-align: center;
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
  }
  h5 {
    margin-top: 14px;
    font-size: 14px;
    color: #595959;
    line-height: 19px;
    font-weight: normal;
  }
  em {
    color: #1c67f3;
    color: var(--main-bg-color);
  }
}
.infoArea {
  width: 600px;
  margin: 51px auto 0;
  .el-input,
  .el-select {
    width: 408px;
  }
  ::v-deep.el-form-item__label {
    padding-right: 20px;
  }
  p {
    width: 408px;
    padding: 8px 12px;
    margin-top: 12px;
    background: #f1f5ff;
    border-radius: 2px;
    font-size: 12px;
    color: #595959;
    line-height: 14px;
  }
  .verificationCode {
    width: 295px;
    margin-right: 8px;
  }
  .el-button.is-plain {
    background: #fff;
    border-color: #1c67f3;
    ::v-deep span {
      color: #1c67f3;
    }
    &.codeBtn.is-disabled {
      border-color: #eceff3;
      ::v-deep span {
        color: #c0c4cc !important;
      }
    }
  }
  .verifyType {
    ::v-deep.el-radio-button__inner {
      width: 158px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d5dbe2;
      margin-right: 16px;
      &:hover {
        color: #1c67f3;
        color: var(--main-bg-color);
      }
    }
    .el-radio-button.is-active {
      ::v-deep.el-radio-button__inner {
        color: #1c67f3;
        color: var(--main-bg-color);
        border: 1px solid #1c67f3;
        border: 1px solid var(--main-bg-color);
        box-shadow: none;
      }
    }
  }
}
.codeArea {
  margin: 24px auto 0;
  width: 160px;
  height: 160px;
  position: relative;
  padding: 11px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dee0e7;
  img {
    width: 100%;
  }
  dl {
    width: 160px;
    height: 160px;
    position: absolute;
    top: -1px;
    left: -1px;
    background: rgba($color: #fff, $alpha: 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  dt {
    width: 36px;
    margin: 0 auto;
  }
  dd {
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    letter-spacing: 1px;
    margin-top: 4px;
  }
}
.demonstration {
  margin-top: 13px;
  width: 244px;
  height: 356px;
  margin-left: 65px;
  img {
    width: 100%;
  }
}
.lineBtn {
  background-color: #fff;
  width: 1600px;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eceef1;
  padding: 12px 0;
  text-align: center;
}
</style>